(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["ducking-good-duck-rescue"] && !Shopify.designMode) return;
  try {
    
  (() => {
    if (window.duckingGoodInlineRescueVideoInitialized) return;
    window.duckingGoodInlineRescueVideoInitialized = true;

    const videoSelector =
      '[data-ducking-good-inline-video-element]';

    const setFullscreenVideoState = (video, isFullscreen) => {
      if (!video) return;

      video.classList.toggle(
        'is-rescue-fullscreen',
        isFullscreen
      );

      if (isFullscreen) {
        video.style.setProperty(
          'object-fit',
          'contain',
          'important'
        );
        video.style.setProperty(
          'object-position',
          'center center',
          'important'
        );
        video.style.setProperty(
          'width',
          '100vw',
          'important'
        );
        video.style.setProperty(
          'height',
          '100vh',
          'important'
        );
        video.style.setProperty(
          'max-width',
          '100vw',
          'important'
        );
        video.style.setProperty(
          'max-height',
          '100vh',
          'important'
        );

        return;
      }

      [
        'object-fit',
        'object-position',
        'width',
        'height',
        'max-width',
        'max-height'
      ].forEach((property) => {
        video.style.removeProperty(property);
      });
    };

    const syncFullscreenState = () => {
      const fullscreenElement =
        document.fullscreenElement ||
        document.webkitFullscreenElement;

      document.querySelectorAll(videoSelector).forEach((video) => {
        const media = video.closest(
          '[data-ducking-good-inline-video]'
        );

        const isFullscreen =
          fullscreenElement === video ||
          fullscreenElement === media ||
          video.webkitDisplayingFullscreen === true;

        setFullscreenVideoState(video, isFullscreen);
      });
    };

    document.addEventListener(
      'fullscreenchange',
      syncFullscreenState
    );

    document.addEventListener(
      'webkitfullscreenchange',
      syncFullscreenState
    );

    document.addEventListener(
      'webkitbeginfullscreen',
      (event) => {
        if (!event.target.matches(videoSelector)) return;

        setFullscreenVideoState(event.target, true);
      },
      true
    );

    document.addEventListener(
      'webkitendfullscreen',
      (event) => {
        if (!event.target.matches(videoSelector)) return;

        setFullscreenVideoState(event.target, false);
      },
      true
    );

    const playVideo = async (trigger) => {
      const mediaId = trigger.getAttribute('aria-controls');
      const media = document.getElementById(mediaId);

      if (!media) return;

      const video = media.querySelector(
        '[data-ducking-good-inline-video-element]'
      );

      if (!video) return;

      document
        .querySelectorAll(
          '[data-ducking-good-inline-video-element]'
        )
        .forEach((otherVideo) => {
          if (otherVideo !== video) {
            otherVideo.pause();
          }
        });

      video.controls = true;
      media.classList.add('is-playing');

      const mediaRect = media.getBoundingClientRect();
      const mediaIsOutsideViewport =
        mediaRect.top < 0 ||
        mediaRect.bottom > window.innerHeight;

      if (mediaIsOutsideViewport) {
        media.scrollIntoView({
          behavior: window.matchMedia(
            '(prefers-reduced-motion: reduce)'
          ).matches
            ? 'auto'
            : 'smooth',
          block: 'center'
        });
      }

      try {
        await video.play();
      } catch (error) {
        media.classList.remove('is-playing');
        video.controls = false;
      }
    };

    const resetVideo = (video) => {
      const media = video.closest(
        '[data-ducking-good-inline-video]'
      );

      if (!media) return;

      media.classList.remove('is-playing');

      video.controls = false;
      video.load();
    };

    document.addEventListener('click', (event) => {
      const trigger = event.target.closest(
        '[data-ducking-good-inline-video-play]'
      );

      if (!trigger) return;

      playVideo(trigger);
    });

    document.addEventListener(
      'ended',
      (event) => {
        if (
          !event.target.matches(
            '[data-ducking-good-inline-video-element]'
          )
        ) {
          return;
        }

        resetVideo(event.target);
      },
      true
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ducking-good-faq"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector = '[data-ducking-good-faq]';
    const itemSelector = '[data-ducking-good-faq-item]';
    const triggerSelector = '[data-ducking-good-faq-trigger]';
    const panelSelector = '[data-ducking-good-faq-panel]';

    const setState = (item, isOpen) => {
      const trigger = item.querySelector(triggerSelector);
      const panel = item.querySelector(panelSelector);

      if (!trigger || !panel) return;

      item.classList.toggle('is-open', isOpen);
      trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      panel.setAttribute('aria-hidden', isOpen ? 'false' : 'true');

      if (isOpen) {
        panel.removeAttribute('inert');
      } else {
        panel.setAttribute('inert', '');
      }
    };

    const initialize = (scope = document) => {
      const sections = scope.matches?.(sectionSelector)
        ? [scope]
        : scope.querySelectorAll(sectionSelector);

      sections.forEach((section) => {
        if (section.dataset.faqInitialized === 'true') return;

        section.dataset.faqInitialized = 'true';
        const allowMultiple = section.dataset.allowMultiple === 'true';
        let openItemFound = false;

        section.querySelectorAll(itemSelector).forEach((item) => {
          const trigger = item.querySelector(triggerSelector);
          let isOpen = trigger?.getAttribute('aria-expanded') === 'true';

          if (!allowMultiple && isOpen) {
            if (openItemFound) {
              isOpen = false;
            } else {
              openItemFound = true;
            }
          }

          setState(item, isOpen);
        });
      });
    };

    if (!window.duckingGoodFaqInitialized) {
      window.duckingGoodFaqInitialized = true;

      document.addEventListener('click', (event) => {
        const trigger = event.target.closest(triggerSelector);
        if (!trigger) return;

        const item = trigger.closest(itemSelector);
        const section = trigger.closest(sectionSelector);

        if (!item || !section) return;

        const isOpen = trigger.getAttribute('aria-expanded') === 'true';
        const allowMultiple = section.dataset.allowMultiple === 'true';

        if (!allowMultiple && !isOpen) {
          section.querySelectorAll(itemSelector).forEach((otherItem) => {
            if (otherItem !== item) {
              setState(otherItem, false);
            }
          });
        }

        setState(item, !isOpen);
      });

      document.addEventListener('shopify:section:load', (event) => {
        initialize(event.target);
      });

      document.addEventListener('shopify:block:select', (event) => {
        const item = event.target.closest?.(itemSelector);
        if (!item) return;

        const section = item.closest(sectionSelector);

        if (section && section.dataset.allowMultiple !== 'true') {
          section.querySelectorAll(itemSelector).forEach((otherItem) => {
            if (otherItem !== item) {
              setState(otherItem, false);
            }
          });
        }

        setState(item, true);
      });
    }

    initialize();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ducking-good-growing-matters"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const sectionSelector =
      '[data-ducking-good-growing-matters]';

    const initializeSection = (section) => {
      if (section.dataset.videoInitialized === 'true') return;

      section.dataset.videoInitialized = 'true';

      const trigger = section.querySelector(
        '[data-ducking-good-growing-video-trigger]'
      );
      const overlay = section.querySelector(
        '[data-ducking-good-growing-video-overlay]'
      );
      const closeButton = section.querySelector(
        '[data-ducking-good-growing-video-close]'
      );
      const video = overlay?.querySelector('video');
      const content = section.querySelector(
        '[data-ducking-good-growing-content]'
      );
      const playButton = overlay?.querySelector(
        '[data-ducking-good-growing-play]'
      );
      const muteButton = overlay?.querySelector(
        '[data-ducking-good-growing-mute]'
      );
      const fullscreenButton = overlay?.querySelector(
        '[data-ducking-good-growing-fullscreen]'
      );
      const progress = overlay?.querySelector(
        '[data-ducking-good-growing-progress]'
      );
      const currentTime = overlay?.querySelector(
        '[data-ducking-good-growing-current-time]'
      );
      const duration = overlay?.querySelector(
        '[data-ducking-good-growing-duration]'
      );

      let controlsHideTimer = null;
      let keyboardInteraction = false;
      const controlsHideDelay = 1800;

      if (
        !trigger ||
        !overlay ||
        !video ||
        !closeButton ||
        !playButton ||
        !muteButton ||
        !fullscreenButton ||
        !progress
      ) {
        return;
      }

      video.controls = false;
      video.removeAttribute('controls');

      const clearControlsHideTimer = () => {
        if (controlsHideTimer === null) return;

        window.clearTimeout(controlsHideTimer);
        controlsHideTimer = null;
      };

      const hideControls = () => {
        if (
          video.paused ||
          (
            keyboardInteraction &&
            overlay.matches(':focus-within')
          )
        ) {
          return;
        }

        section.classList.add('is-controls-hidden');
      };

      const scheduleControlsHide = () => {
        clearControlsHideTimer();

        if (video.paused) return;

        controlsHideTimer = window.setTimeout(
          hideControls,
          controlsHideDelay
        );
      };

      const showControls = () => {
        section.classList.remove('is-controls-hidden');
        scheduleControlsHide();
      };

      const formatTime = (seconds) => {
        if (!Number.isFinite(seconds)) return '0:00';

        const minutes = Math.floor(seconds / 60);
        const remainingSeconds = Math.floor(seconds % 60)
          .toString()
          .padStart(2, '0');

        return `${minutes}:${remainingSeconds}`;
      };

      const syncPlaybackState = () => {
        const isPaused = video.paused;

        section.classList.toggle('is-video-paused', isPaused);
        playButton.setAttribute(
          'aria-label',
          isPaused ? 'Play video' : 'Pause video'
        );

        if (isPaused) {
          clearControlsHideTimer();
          section.classList.remove('is-controls-hidden');
        } else {
          showControls();
        }
      };

      const syncMutedState = () => {
        section.classList.toggle('is-video-muted', video.muted);
        muteButton.setAttribute(
          'aria-label',
          video.muted ? 'Unmute video' : 'Mute video'
        );
      };

      const syncProgress = () => {
        const percent = video.duration
          ? (video.currentTime / video.duration) * 100
          : 0;

        progress.value = percent;

        if (currentTime) {
          currentTime.textContent = formatTime(video.currentTime);
        }

        if (duration) {
          duration.textContent = formatTime(video.duration);
        }
      };

      const openVideo = async () => {
        section.classList.add('is-video-open');
        section.classList.remove('is-controls-hidden');
        overlay.setAttribute('aria-hidden', 'false');
        trigger.setAttribute('aria-expanded', 'true');
        content?.setAttribute('inert', '');

        try {
          video.currentTime = 0;
        } catch (error) {
          /* Metadata may not be loaded yet. */
        }

        try {
          await video.play();
        } catch (error) {
          /* Native controls remain available if autoplay is blocked. */
        }

        if (keyboardInteraction) {
          window.setTimeout(() => {
            closeButton.focus();
          }, 350);
        }
      };

      const closeVideo = () => {
        clearControlsHideTimer();
        section.classList.remove('is-controls-hidden');
        video.pause();

        try {
          video.currentTime = 0;
        } catch (error) {
          /* Metadata may not be loaded yet. */
        }

        section.classList.remove('is-video-open');
        overlay.setAttribute('aria-hidden', 'true');
        trigger.setAttribute('aria-expanded', 'false');
        content?.removeAttribute('inert');
        trigger.focus();
      };

      trigger.addEventListener('pointerdown', () => {
        keyboardInteraction = false;
      });

      trigger.addEventListener('keydown', (event) => {
        if (
          event.key === 'Enter' ||
          event.key === ' '
        ) {
          keyboardInteraction = true;
        }
      });

      overlay.addEventListener('pointermove', () => {
        keyboardInteraction = false;
        showControls();
      });

      overlay.addEventListener('pointerenter', () => {
        keyboardInteraction = false;
        showControls();
      });

      overlay.addEventListener('touchstart', () => {
        keyboardInteraction = false;
        showControls();
      }, {
        passive: true
      });

      overlay.addEventListener('focusin', () => {
        keyboardInteraction = true;
        clearControlsHideTimer();
        section.classList.remove('is-controls-hidden');
      });

      overlay.addEventListener('focusout', () => {
        window.setTimeout(() => {
          if (!overlay.matches(':focus-within')) {
            keyboardInteraction = false;
            scheduleControlsHide();
          }
        }, 0);
      });

      overlay.addEventListener('pointerleave', () => {
        keyboardInteraction = false;

        if (!video.paused) {
          clearControlsHideTimer();

          controlsHideTimer = window.setTimeout(
            hideControls,
            250
          );
        }
      });

      playButton.addEventListener('click', async () => {
        if (video.paused) {
          try {
            await video.play();
          } catch (error) {
            /* Playback may require another user gesture. */
          }
        } else {
          video.pause();
        }
      });

      muteButton.addEventListener('click', () => {
        video.muted = !video.muted;
        syncMutedState();
      });

      progress.addEventListener('input', () => {
        clearControlsHideTimer();
        section.classList.remove('is-controls-hidden');

        if (!video.duration) return;

        video.currentTime =
          (Number(progress.value) / 100) * video.duration;
      });

      progress.addEventListener(
        'change',
        scheduleControlsHide
      );

      fullscreenButton.addEventListener('click', async () => {
        try {
          if (document.fullscreenElement) {
            await document.exitFullscreen();
          } else if (overlay.requestFullscreen) {
            await overlay.requestFullscreen();
          } else if (video.webkitEnterFullscreen) {
            video.webkitEnterFullscreen();
          }
        } catch (error) {
          /* Fullscreen may be unavailable in the current browser. */
        }
      });

      video.addEventListener('play', syncPlaybackState);
      video.addEventListener('pause', syncPlaybackState);
      video.addEventListener('volumechange', syncMutedState);
      video.addEventListener('timeupdate', syncProgress);
      video.addEventListener('loadedmetadata', syncProgress);
      video.addEventListener('durationchange', syncProgress);

      syncPlaybackState();
      syncMutedState();
      syncProgress();

      trigger.addEventListener('click', openVideo);
      closeButton.addEventListener('click', closeVideo);

      section.addEventListener('keydown', (event) => {
        if (
          event.key === 'Escape' &&
          section.classList.contains('is-video-open')
        ) {
          closeVideo();
        }
      });

      video.addEventListener('ended', closeVideo);
    };

    const initializeSections = (scope = document) => {
      if (scope.matches?.(sectionSelector)) {
        initializeSection(scope);
        return;
      }

      scope
        .querySelectorAll(sectionSelector)
        .forEach(initializeSection);
    };

    initializeSections();

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        initializeSections(event.target);
      }
    );
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ducking-good-hero"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const heroSelector = '[data-ducking-good-hero]';
    const desktopMediaSelector =
      '.ducking-good-hero__media--desktop';
    const mobileMediaSelector =
      '.ducking-good-hero__media--mobile';
    const introSelector =
      '.ducking-good-hero__video-element--intro';
    const loopSelector =
      '.ducking-good-hero__video-element--loop';
    const replaySelector = '[data-ducking-good-hero-replay]';
    const handwritingArtworkSelector =
      '[data-ducking-good-handwriting-artwork]';
    const mobileMediaQuery = window.matchMedia(
      '(max-width: 1023px)'
    );

    const waitForRenderedFrame = (video, callback) => {
      const runCallback = () => {
        if (typeof video.requestVideoFrameCallback === 'function') {
          video.requestVideoFrameCallback(callback);
          return;
        }

        window.requestAnimationFrame(() => {
          window.requestAnimationFrame(callback);
        });
      };

      if (video.readyState >= 2) {
        runCallback();
        return;
      }

      video.addEventListener('loadeddata', runCallback, {
        once: true
      });
    };

    const initializeHero = (hero) => {
      if (hero.dataset.videoSequenceInitialized === 'true') return;

      hero.dataset.videoSequenceInitialized = 'true';

      const desktopMedia = hero.querySelector(
        desktopMediaSelector
      );
      const mobileMedia = hero.querySelector(
        mobileMediaSelector
      );
      const replayButton = hero.querySelector(replaySelector);
      const handwritingDelay =
        Number.parseInt(hero.dataset.handwritingDelay, 10) || 1800;

      let activeMedia = null;
      let introVideo = null;
      let loopVideo = null;
      let sequenceId = 0;
      let loopStarted = false;
      let handwritingScheduled = false;
      let handwritingTimer = null;

      const getActiveMedia = () => {
        if (mobileMediaQuery.matches && mobileMedia) {
          return mobileMedia;
        }

        return desktopMedia || mobileMedia;
      };

      const updateActiveVideos = () => {
        activeMedia = getActiveMedia();
        introVideo = activeMedia?.querySelector(introSelector) || null;
        loopVideo = activeMedia?.querySelector(loopSelector) || null;
      };

      const revealButtonWhenFontsReady = () => {
        let hasRevealed = false;

        const reveal = () => {
          if (hasRevealed) return;

          hasRevealed = true;
          hero.classList.add('is-fonts-ready');
        };

        if (document.fonts?.ready) {
          document.fonts.ready.then(reveal).catch(reveal);
          window.setTimeout(reveal, 3000);
        } else {
          window.requestAnimationFrame(reveal);
        }
      };

      const clearHandwritingImage = () => {
        const artwork = hero.querySelector(
          handwritingArtworkSelector
        );

        artwork
          ?.querySelector(
            '.ducking-good-hero__handwriting-image'
          )
          ?.remove();
      };

      const restartHandwritingImage = (
        currentSequenceId
      ) =>
        new Promise((resolve) => {
          const artwork = hero.querySelector(
            handwritingArtworkSelector
          );

          const baseSrc = artwork?.dataset.handwritingSrc;

          if (!artwork || !baseSrc) {
            resolve();
            return;
          }

          clearHandwritingImage();

          const image = new Image();
          const separator = baseSrc.includes('?') ? '&' : '?';

          image.className =
            'ducking-good-hero__handwriting-image';
          image.alt = '';
          image.decoding = 'async';
          image.fetchPriority = 'high';

          const finish = () => {
            image.removeEventListener('load', finish);
            image.removeEventListener('error', finish);
            resolve();
          };

          image.addEventListener('load', finish);
          image.addEventListener('error', finish);

          artwork.appendChild(image);

          image.src =
            `${baseSrc}${separator}replay=` +
            `${currentSequenceId}-${Date.now()}`;

          if (image.complete) {
            finish();
          }
        });

      const clearHandwritingTimer = () => {
        if (handwritingTimer === null) return;

        window.clearTimeout(handwritingTimer);
        handwritingTimer = null;
      };

      const scheduleHandwriting = (currentSequenceId) => {
        if (handwritingScheduled) return;

        handwritingScheduled = true;
        clearHandwritingTimer();

        handwritingTimer = window.setTimeout(async () => {
          if (currentSequenceId !== sequenceId) return;

          await restartHandwritingImage(currentSequenceId);

          if (currentSequenceId !== sequenceId) return;

          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
              if (currentSequenceId !== sequenceId) return;

              hero.classList.add('is-handwriting-visible');
            });
          });
        }, handwritingDelay);
      };

      const resetVideo = (video) => {
        if (!video) return;

        video.pause();

        try {
          video.currentTime = 0;
        } catch (error) {
          /* Metadata may not be loaded yet. */
        }
      };

      const resetAllVideos = () => {
        hero
          .querySelectorAll(
            '.ducking-good-hero__video-element'
          )
          .forEach(resetVideo);
      };

      const prepareIntroVideo = () => {
        if (!introVideo) return;

        introVideo.preload = 'auto';

        if (introVideo.readyState < 2) {
          introVideo.load();
        }
      };

      const warmLoopVideo = () => {
        if (!loopVideo) return;

        loopVideo.preload = 'auto';

        if (loopVideo.readyState < 2) {
          loopVideo.load();
        }
      };

      const revealIntroVideo = (currentSequenceId) => {
        if (!introVideo) return;

        waitForRenderedFrame(introVideo, () => {
          if (currentSequenceId !== sequenceId) return;

          hero.classList.add('is-intro-ready', 'is-video-ready');
        });
      };

      const revealLoopVideo = (currentSequenceId) => {
        if (!loopVideo) return;

        waitForRenderedFrame(loopVideo, () => {
          if (currentSequenceId !== sequenceId) return;

          hero.classList.add('is-looping', 'is-video-ready');

          if (introVideo) {
            introVideo.pause();
          }
        });
      };

      const startLoopVideo = async (currentSequenceId) => {
        if (
          !loopVideo ||
          loopStarted ||
          currentSequenceId !== sequenceId
        ) {
          return;
        }

        loopStarted = true;
        loopVideo.muted = true;
        loopVideo.defaultMuted = true;
        loopVideo.loop = true;
        warmLoopVideo();

        try {
          if (loopVideo.readyState > 0) {
            loopVideo.currentTime = 0;
          }

          await loopVideo.play();

          if (currentSequenceId !== sequenceId) {
            loopVideo.pause();
            return;
          }

          scheduleHandwriting(currentSequenceId);
          revealLoopVideo(currentSequenceId);
        } catch (error) {
          loopStarted = false;
        }
      };

      const handleIntroPlaying = (
        video,
        currentSequenceId
      ) => {
        if (
          video !== introVideo ||
          currentSequenceId !== sequenceId
        ) {
          return;
        }

        scheduleHandwriting(currentSequenceId);
        revealIntroVideo(currentSequenceId);

        if (!loopVideo) return;

        if ('requestIdleCallback' in window) {
          window.requestIdleCallback(warmLoopVideo, {
            timeout: 1000
          });
        } else {
          window.setTimeout(warmLoopVideo, 250);
        }
      };

      const startSequence = async () => {
        sequenceId += 1;

        const currentSequenceId = sequenceId;

        clearHandwritingTimer();
        handwritingScheduled = false;
        loopStarted = false;

        hero.classList.remove(
          'is-intro-ready',
          'is-looping',
          'is-video-ready',
          'is-handwriting-visible'
        );

        clearHandwritingImage();
        resetAllVideos();
        updateActiveVideos();

        if (introVideo) {
          introVideo.muted = true;
          introVideo.defaultMuted = true;
          prepareIntroVideo();

          try {
            if (introVideo.readyState > 0) {
              introVideo.currentTime = 0;
            }

            await introVideo.play();
            handleIntroPlaying(introVideo, currentSequenceId);
          } catch (error) {
            if (loopVideo) {
              startLoopVideo(currentSequenceId);
            } else {
              scheduleHandwriting(currentSequenceId);
            }
          }

          return;
        }

        if (loopVideo) {
          startLoopVideo(currentSequenceId);
          return;
        }

        scheduleHandwriting(currentSequenceId);
      };

      hero.querySelectorAll(introSelector).forEach((video) => {
        video.addEventListener('playing', () => {
          handleIntroPlaying(video, sequenceId);
        });

        video.addEventListener('ended', () => {
          if (video !== introVideo) return;

          startLoopVideo(sequenceId);
        });
      });

      replayButton?.addEventListener('click', () => {
        hero.classList.remove('is-replaying');

        window.requestAnimationFrame(() => {
          hero.classList.add('is-replaying');

          window.setTimeout(() => {
            hero.classList.remove('is-replaying');
          }, 600);
        });

        startSequence();
      });

      if (mobileMedia) {
        const handleMediaChange = () => {
          startSequence();
        };

        if (typeof mobileMediaQuery.addEventListener === 'function') {
          mobileMediaQuery.addEventListener(
            'change',
            handleMediaChange
          );
        } else {
          mobileMediaQuery.addListener(handleMediaChange);
        }
      }

      revealButtonWhenFontsReady();
      startSequence();
    };

    const initializeHeroes = (scope = document) => {
      if (scope.matches?.(heroSelector)) {
        initializeHero(scope);
        return;
      }

      scope
        .querySelectorAll(heroSelector)
        .forEach(initializeHero);
    };

    initializeHeroes();

    document.addEventListener(
      'shopify:section:load',
      (event) => {
        initializeHeroes(event.target);
      }
    );
  })();

  } catch(e) { console.error(e); }
})();
})();
